import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { GoogleAnalyticsService, NgxGoogleAnalyticsModule } from '@hakimio/ngx-google-analytics';
import { LanguageService } from 'portal/core/language/language.service';
import { TitleService } from 'portal/core/title/title.service';
import { isPreviewPath } from 'portal/core/preview/preview-document';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    NgxGoogleAnalyticsModule,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  readonly #ga = inject(GoogleAnalyticsService);
  readonly #router = inject(Router);
  readonly #language = inject(LanguageService);
  readonly #translate = inject(TranslateService);
  readonly #title = inject(TitleService);

  readonly #navigationEnd = this.#router.events.pipe(
    filter(event => event instanceof NavigationEnd),
  );

  constructor() {
    this.#navigationEnd.subscribe(event => {
      if (isPreviewPath(event.urlAfterRedirects)) {
        return;
      }

      this.#ga.pageView(event.urlAfterRedirects, {
        title: event.urlAfterRedirects
      });
    });

    effect(() => {
      this.#translate.use(this.#language.language());
      this.#title.updateTitle(this.#router.routerState.snapshot);
    });
  }
}
